import React from 'react';
import { LogoLoading } from './LogoLoading';

interface LoadingScreenProps {
  message?: string;
  showSpinner?: boolean;
  size?: 'x-small' | 'small' | 'medium' | 'large';
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = "Carregando...", 
  showSpinner = true,
  size = 'medium'
}) => {
  const sizeMap = {
    'x-small': { logo: 40, text: 'text-sm' },
    small: { logo: 80, text: 'text-lg' },
    medium: { logo: 120, text: 'text-2xl' },
    large: { logo: 160, text: 'text-3xl' },
  };

  const { logo: logoSize, text: textSize } = sizeMap[size];

  return (
    <div className="fixed inset-0 bg-white dark:bg-gray-900 flex flex-col items-center justify-center z-50">
      {/* Logo animado */}
      <LogoLoading size={logoSize} className="mb-6" />
      
      {/* Mensagem de loading */}
      <div className="text-center">
        <h2 className={`font-extrabold text-gray-800 dark:text-gray-200 mb-2 ${textSize}`}>
          {message}
        </h2>
        
        {/* Spinner opcional */}
        {showSpinner && (
          <div className="mt-3">
            <div className="inline-block w-5 h-5 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
          </div>
        )}
      </div>
    </div>
  );
};
